// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2G-bR","card":"Cards_card__3D-Ba","infected":"Cards_infected__1x0fY","recovered":"Cards_recovered__n_7JU","deaths":"Cards_deaths__9jRCM"};